import styled from 'styled-components';
import { media } from '@app/styles/themes/constants';
import { BaseLayout } from '@app/components/common/BaseLayout/BaseLayout';

export const LayoutMaster = styled(BaseLayout)`
  height: 100vh;
  /* dvh: trừ đúng phần thanh URL của trình duyệt mobile (fallback vh cho trình duyệt cũ) */
  height: 100dvh;
  overflow: hidden;
`;

export const LayoutMain = styled(BaseLayout)`
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
  overflow-x: hidden;

  @media only screen and ${media.md} {
    margin-left: 80px;
  }

  @media only screen and ${media.xl} {
    margin-left: unset;
  }
`;

export const Breadcrumb = styled(BaseLayout)`
  margin: 0;
`;
